import { render, staticRenderFns } from "./SGReadyHomeEnergyCard.vue?vue&type=template&id=513147bc&scoped=true&"
import script from "./SGReadyHomeEnergyCard.vue?vue&type=script&lang=js&"
export * from "./SGReadyHomeEnergyCard.vue?vue&type=script&lang=js&"
import style0 from "./SGReadyHomeEnergyCard.vue?vue&type=style&index=0&id=513147bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513147bc",
  null
  
)

export default component.exports